<div class="kt-portlet">
	<div class="kt-portlet__body">
		<mat-label><b>Current Versions</b></mat-label>
		<br>
		<div class="mat-table__wrapper mb-3">
			<mat-table [dataSource]="versionData" class="lmat-elevation-z8">

				<ng-container matColumnDef="ui_cv">
				  <mat-header-cell *matHeaderCellDef> UI Current </mat-header-cell>
				  <mat-cell *matCellDef="let element"> {{element.ui_cv || '-'}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="ui_av">
				  <mat-header-cell *matHeaderCellDef> UI Available </mat-header-cell>
				  <mat-cell *matCellDef="let element"> {{element.ui_av || '-'}} </mat-cell>
				</ng-container>

				<ng-container matColumnDef="menu_cv">
					<mat-header-cell *matHeaderCellDef> Menu Current </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.menu_cv || '-'}} </mat-cell>
				  </ng-container>

				  <ng-container matColumnDef="menu_av">
					<mat-header-cell *matHeaderCellDef> Menu Available </mat-header-cell>
					<mat-cell *matCellDef="let element"> {{element.menu_av || '-'}} </mat-cell>
				  </ng-container>

				<ng-container matColumnDef="aux_cv">
				  <mat-header-cell *matHeaderCellDef> Aux Current </mat-header-cell>
				  <mat-cell *matCellDef="let element"> {{element.aux_cv || '-'}} </mat-cell>
				</ng-container>


				<ng-container matColumnDef="aux_av">
				  <mat-header-cell *matHeaderCellDef> Aux Available </mat-header-cell>
				  <mat-cell *matCellDef="let element"> {{element.aux_av || '-'}} </mat-cell>
				</ng-container>

				<mat-header-row *matHeaderRowDef="dispColsVer"></mat-header-row>
				<mat-row *matRowDef="let row; columns: dispColsVer;"></mat-row>
			  </mat-table>

		</div>

		<mat-label *ngIf="roleIndex <= 1" class="mt-5"><b>Assign Package</b></mat-label>
		<br>

		<!-- start::FILTERS & GROUP ACTIONS -->
		<div *ngIf="roleIndex <= 1" class="kt-form kt-margin-b-30">
			<!-- start::FILTERS -->
			<div class="hierarchical-filters">
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select type</label>
					<kt-searchable-select
						[options]="typeOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="typeSelected"
						(selectionChange)="typeChanged($event)">
					</kt-searchable-select>
				</div>
				<div class="scope-select-wrapper">
					<label class="scope-select-label">Select mode</label>
					<kt-searchable-select
						[options]="modeOptions"
						[multiple]="false"
						[searchable]="false"
						[(ngModel)]="modeSelected"
						(selectionChange)="modeChanged($event)">
					</kt-searchable-select>
				</div>
			</div>
			<!-- end::FILTERS -->
		</div>
		<!-- end::FILTERS & GROUP ACTIONS -->

		<br>

		<!-- -------table starts--------- -->
			<div class="mat-table__wrapper">
				<mat-table class="lmat-elevation-z8"
					#table
					[dataSource]="dataSource"
					matSort
					matSortActive="uploaded_at"
					matSortDirection="desc"
					matSortDisableClear>

					<ng-container matColumnDef="file_version">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Version</mat-header-cell>
						<mat-cell *matCellDef="let file">
							{{file.file_version}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="file_desc">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
						<mat-cell *matCellDef="let file">{{file.file_desc}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="file_name">
						<mat-header-cell *matHeaderCellDef mat-sort-header>File Name</mat-header-cell>
						<mat-cell *matCellDef="let file">{{file.file_name}}</mat-cell>
					</ng-container>

					<ng-container matColumnDef="uploaded_at">
						<mat-header-cell *matHeaderCellDef mat-sort-header>Uploaded at</mat-header-cell>
						<mat-cell *matCellDef="let file">
							{{file.uploaded_at}}
						</mat-cell>
					</ng-container>

					<ng-container matColumnDef="actions">
						<mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
						<mat-cell *matCellDef="let file">
							<button (click)="checkMode(file)" mat-icon-button color="primary" matTooltip="Assign">
								<mat-icon>send</mat-icon>
							</button>
						</mat-cell>
					</ng-container>

					<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
					<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
				</mat-table>

				<div class="mat-table__message" *ngIf="(!modeSelected || !typeSelected)">Please select file type and mode</div>
				<div class="mat-table__message" *ngIf="(dataSource.loading$ | async)">Please wait....</div>
				<div class="mat-table__message" *ngIf="dataSource.empty">No records found</div>

			<div class="mat-table__bottom">
				<mat-spinner [diameter]="20" *ngIf="dataSource.loading$ | async"></mat-spinner>
				<mat-paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 50, 100]"  [showFirstLastButtons]="true"></mat-paginator>
			</div>
		</div>

		<!-- -----end of table-------- -->
	</div>

</div>
